module.exports = __webpack_public_path__ + "static/media/404.7a28d6e4.svg";